import { render, staticRenderFns } from "./TabPanelVinculos.vue?vue&type=template&id=d63f8eca&scoped=true&"
import script from "./TabPanelVinculos.vue?vue&type=script&lang=js&"
export * from "./TabPanelVinculos.vue?vue&type=script&lang=js&"
import style0 from "./TabPanelVinculos.vue?vue&type=style&index=0&id=d63f8eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63f8eca",
  null
  
)

export default component.exports